import { ImageMessage, AudioMessage, VideoMessage, DownloadMessage } from './MediaMessage';
import TextMessage from './TextMessage';
import WhatsappFlowMessage from './WhatsappFlowMessage';
import WabaTemplateMessage from './WabaTemplateMessage';

export default function Message({ message }) {
  // Helper function to detect flow messages
  const isFlowMessage = (message) => {
    if (message.message_content) {
      try {
        const content = JSON.parse(message.message_content);
        if (content.type === 'flow') {
          return true;
        }
      } catch (e) {
        // Not JSON, continue
      }
    }
    return false;
  };

  // Helper function to detect WABA template messages
  const isWabaTemplateMessage = (message) => {
    if (message.message_content) {
      try {
        const content = JSON.parse(message.message_content);
        return content.header !== undefined || content.body !== undefined || content.footer !== undefined;
      } catch (e) {
        // Not JSON, continue
      }
    }
    return false;
  };

  if (message.message_type && message.message_type.startsWith('image')) {
    return <ImageMessage message={message} />;
  } else if (message.message_type && message.message_type.startsWith('audio')) {
    return <AudioMessage message={message} />;
  } else if (message.message_type && message.message_type.startsWith('video')) {
    return <VideoMessage message={message} />;
  } else if (message.media_url) {
    return <DownloadMessage message={message} />;
  } else if (isFlowMessage(message)) {
    return <WhatsappFlowMessage message={message} />;
  } else if (isWabaTemplateMessage(message)) {
    return <WabaTemplateMessage message={message} />;
  } else {
    return <TextMessage message={message} />;
  }
}
